<template>
	<div class="Wallet">
		<div class="Wallet_header"><SecondHead class="header_SecondHead"></SecondHead></div>
		<div class="Wallet_main">
			<div class="Wallet_account_my">
				<div class="myBalance">
					<div class="p_line"></div>
					<span class="p_line_span">{{$t('Mywallet.MyAccount')}}</span>
				</div>
				<ul class="myMoney">
					<li class="myMoneyli">
						<p class="lip">{{$t('Mywallet.AvailableBalance')}}</p>
						<div class="liMoney">
							<span class="mspan usable">{{ DataMoney.usableMoney | toFixed(2) }}</span>
							<span class="mspan2">{{$t('Mywallet.RMB')}}</span>
						</div>
						<div>
							<RechargeAmount @payment="payment"></RechargeAmount>
							<el-button type="primary" @click="open1">{{$t('Mywallet.Withdrawal')}}</el-button>
						</div>
					</li>
					<li class="myMoneyli">
						<p class="lip">{{$t('Mywallet.ExpenditureAmount')}}</p>
						<div class="liMoney">
							<span class="mspan expenditure">{{ DataMoney.redPacketMoney | toFixed(2)}}</span>
							<span class="mspan2">{{$t('Mywallet.RMB')}}</span>
						</div>
						<div>
							<el-button type="primary" @click="record">{{$t('Mywallet.TransactionRecords')}}</el-button>
							<el-button type="primary" @click="open1">{{$t('Mywallet.ApplyForInvoice')}}</el-button>
						</div>
					</li>
					<li class="myMoneyli">
						<p class="lip">{{$t('Mywallet.Withdrawing')}}</p>
						<div class="liMoney">
							<span class="mspan">{{ DataMoney.withdrawalMoney | toFixed(2) }}</span>
							<span class="mspan2">{{$t('Mywallet.RMB')}}</span>
						</div>
						<div class="lifoot">{{$t('Mywallet.BalanceWithdrawalProcess')}}</div>
					</li>
					<li class="myMoneyli">
						<p class="lip">{{$t('Mywallet.InUse')}}</p>
						<div class="liMoney">
							<span class="mspan">{{ DataMoney.employMoney | toFixed(2) }}</span>
							<span class="mspan2">{{$t('Mywallet.RMB')}}</span>
						</div>
						<div class="lifoot">{{$t('Mywallet.OccupationAmount')}}</div>
					</li>
				</ul>
			</div>
		</div>
		<!-- 对话框 -->
		
	</div>
</template>

<script>
import SecondHead from '@/components/SecondHead';
import RechargeAmount from '@/components/RechargeAmount';
export default {
	name: 'Mywallet',
	components: {
		SecondHead,
		RechargeAmount
	},
	data() {
		return {
			payMoney: '', //充值账户
			total: 1,
			pageIndex: 1,
			pageSize: 10,
			go: -1,
			activeName: 'first',
			DataMoney: {} //金钱
		};
	},
	mounted: function() {
		this.queryDownloadRecord();
	},
	methods: {
		payment(val){
			console.log(val)
		},
		open1() {
		        const h = this.$createElement;
		        this.$notify.info({
					title: this.$t('main.tip'),
					message: this.$t('Mywallet.MyAccount'),
					duration:2400
				});
		      },
		
		record() {
			this.$router.push({ path: '/TransactionRecord' });
		},
		
		queryDownloadRecord() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.mywallet}`,
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.DataMoney = res.resultBody;
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
.Wallet {
	width: 100%;
	min-height: 100%;
	background-color: #f5f5f5;
	.Wallet_header {
		width: 100%;
		height: 68px;
		background-color: #fff;
		.header_SecondHead {
			max-width: 1200px;
			margin: auto;
		}
	}
	.Wallet_main {
		width: 100%;
		height: 100%;
		.Wallet_account_my {
			max-width: 1200px;
			height: 800px;
			margin: 30px auto;
			background-color: #fff;
			.myBalance {
				display: flex;
				height: 87px;
				line-height: 87px;
				.p_line {
					width: 4px;
					height: 20px;
					background: #0080ff;
					margin-right: 15px;
					margin: 34px 15px 0px 34px;
				}
				.p_line_span {
					color: #333;
					fong-size: 16px;
				}
			}
			.myMoney {
				display: flex;
				justify-content: space-around;
				.myMoneyli {
					width: 240px;
					height: 280px;
					border: 1px solid #e1e1e1;
					text-align: center;
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					.lip {
						font-size: 18px;
						color: #333;
					}
					.liMoney {
						height: 25px;
						.mspan {
							font-size: 30px;
						}
						.mspan2 {
							margin-left: 5px;
						}
						//不同金钱的
						.usable {
							color: #f54b4b;
						}
						.expenditure {
							color: #3cc022;
						}
					}
					.lifoot {
						height: 40px;
						line-height: 40px;
						font-size: 14px;
						color: #666;
					}
				}
			}
		}
	}
	
}
</style>
